import React from 'react';

export interface Testimonial {
  quote: string;
  author: string;
  role: string;
}

export interface ProcessStep {
  title: string;
  description: string;
  items: string[];
}

export enum ServiceType {
  LAUNCH = 'LAUNCH',
  CONTRACT = 'CONTRACT'
}

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: React.ReactNode; // Can be string or JSX
  author: string;
  role: string;
  date: string;
  category: string;
  imageUrl: string;
  readTime: string;
}